export enum SceneName {
  BootGame = "BootGame",
  StartScene = "StartScene",
  GameControllerScene = "GameControllerScene",
  EditScene = "EditScene",
  TransitionGameIntroCut = "TransitionGameIntroCut",
  MapScene = "MapScene",
  IntroCardScene = "IntroCardScene",
  TitleScene = "TitleScene",
}

export const BOARD_SIZE = 8;
export const DEV_MODE = false; // window.location.search.substring(1).includes("dev");

export const FIRST_LEVEL_KEY = "Overworld_pre";

export const GAME_VARIABLES = {
  MOVE_TIME_MS: 90,
  OBJ_ID: 1,
  IS_RESTART: false,
};

export const layerDepthDiff = {
  FLOOR: -1.3,
  BUTTON: -0.05,
  BOXES: 0.04,
  WALLS: 0.09,
  LAZORTOGGLE: 0.11,
  PLAYER: 0.1,
  FRONT: 0.3,
};

// Return unique Id
export const getId = function (): number {
  return GAME_VARIABLES.OBJ_ID++;
};

export enum GameEvents {
  PlayerMadeTurn = "E_P_turn",
  AddAndRemoveEntities = "E_remove",
  TurnFinished = "E_TurnFinished",
  PressurePlateState = "E_Pressure_Plate",
  FX_DoorToggled = "E_FX_DoorToggled",
  FX_Explosion = "E_FX_Explode",
  PlayerShot = "E_FX_PlayerShot",
  PlayerWonLevel = "WonLevel",
  PlayerDied = "PlayerDied",
  UNDO_Pressed = "afterUndo",
  TurnDebounceStart = "TurnDebounceStart",
  SceneTransitionStarted = "SceneTransitionStarted",
  SceneTransitionEnded = "SceneTransitionEnded",
  OneShotFX = "OneShotFX",
}
